var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("pr-recommendations-bulk-update-upload", {
        attrs: { "show-bulk-update": _vm.showPrRecommendationsBulkUpdateModal },
        on: {
          close: function ($event) {
            _vm.showPrRecommendationsBulkUpdateModal = false
          },
        },
      }),
      _c("hydro-data-bulk-update-upload", {
        attrs: { "show-bulk-update": _vm.showHydroDataBulkUpdateModal },
        on: {
          close: function ($event) {
            _vm.showHydroDataBulkUpdateModal = false
          },
        },
      }),
      _c("hydro-data-download-template", {
        attrs: {
          "show-download-template": _vm.showHydroDataDownloadTemplateModal,
        },
        on: {
          close: function ($event) {
            _vm.showHydroDataDownloadTemplateModal = false
          },
        },
      }),
      _c("content-wrapper", {
        scopedSlots: _vm._u([
          {
            key: "filters",
            fn: function () {
              return [
                _c("div", { staticClass: "flex-container pl-2" }, [
                  _c("div", { staticClass: "flex-row flex-4" }, [
                    _c("h3", { staticClass: "select-title" }, [
                      _vm._v(_vm._s(_vm.$t("dataTypes"))),
                    ]),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedDataType,
                            expression: "selectedDataType",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { id: "dataType" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedDataType = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      _vm._l(_vm.dataTypes, function (option, i) {
                        return _c(
                          "option",
                          {
                            key: i,
                            domProps: {
                              value: option,
                              selected: _vm.selectedDataType,
                            },
                          },
                          [_vm._v(" " + _vm._s(option) + " ")]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _vm.loading
                  ? _c("div", { staticClass: "popup" }, [_c("eas-loader")], 1)
                  : _vm._e(),
                _c("h2", { staticClass: "mr-2 ml-2" }, [
                  _vm._v(" " + _vm._s(_vm.selectedDataType) + " "),
                ]),
                _c("div", { staticClass: "mr-2 ml-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn data-management-btn",
                      on: { click: _vm.downloadTemplate },
                    },
                    [_vm._v(_vm._s(_vm.$t("downloadTemplate")))]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn data-management-btn",
                      on: { click: _vm.showBulkUpdate },
                    },
                    [_vm._v(_vm._s(_vm.$t("bulkUpdate")))]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }